import React, { useEffect, useState } from "react"

// components
import Banner from "../components/banner"
// import PageTitle from "../components/pageTitle"
import AudioCard from "../components/audioCard"
import Footer from "../components/footer"
import Pagination from "../components/pagination"

// data
import audios from "../data/audios"

const Audio = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [songsPerPage] = useState([5])

  useEffect(() => {
    document.title = "Audios - Soz the govt Music Production"
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const indexOfLastSong = currentPage * songsPerPage
  const indexOfFirstSong = indexOfLastSong - songsPerPage
  const currentSongs = audios.slice(indexOfFirstSong, indexOfLastSong)

  const paginate = (pageNumber) => setCurrentPage(pageNumber)

  return (
    <div className="media-page">
      <Banner bannerClass="media-banner audios-banner">
        <h1>Beats</h1>
      </Banner>
      {/* <PageTitle
        title="Take a look on what we create"
        subtitle="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio."
      ></PageTitle> */}
      <main>
        <div className="container">
          <article className="row">
            <section className="column">
              <div className="showcase">
                {currentSongs.map((audio, index) => (
                  <AudioCard
                    key={index}
                    id={audio.id}
                    title={audio.title}
                    descr={audio.descr}
                    src={audio.src}
                    type={audio.type}
                  />
                ))}
              </div>
            </section>
            <Pagination
              songsPerPage={songsPerPage}
              totalSongs={audios.length}
              paginate={paginate}
              indexOfLastSong={indexOfLastSong}
            />
          </article>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Audio
